import Header from "./Compartido/Header";
import HeroSection from "./Inicio/HeroSection";
import Buscador from "./Inicio/Buscador";
import ValueSection from "./Inicio//ValueSection";
import Noticias from "./Inicio/Noticias";
import RewardsSection from "./Inicio/RewardsSection";
import ExperiencesSection from "./Inicio/ExperiencesSection";
import BrandsSection from "./Compartido/BrandsSection";
import Footer from "./Compartido/Footer";

const Inicio = (props) => {
    return (
        <>
            <main className="min-h-screen">
                <Header
                    config={props.websgrupo}
                    lang={props.lang}
                    meta_titulo={props.meta_titulo}
                    meta_descripcion={props.meta_descripcion}
                    meta_keywords={props.meta_keywords}
                    ruta={props.ruta}
                    idiomas={props.idiomas}
                    destinos={props.destinos}
                    experiencias={props.experiencias}
                />
                <HeroSection
                    destinos={props.destinos}
                    ruta={props.ruta}
                    lang={props.lang}
                />
                <Buscador
                    lang={props.lang}
                    destinos={props.destinos}
                    capacidad_maxima={props.capacidad_maxima}
                />
                <div className="container">
                    <ValueSection
                        elementosweb={props.elementosweb}
                        lang={props.lang}
                        destinos={props.destinos}
                        ruta={props.ruta}
                    />
                    {props.noticias && props.noticias.length > 0 ?
                        <Noticias
                            noticias={props.noticias}
                            ruta={props.ruta}
                            lang={props.lang}
                            config={props.websgrupo}
                        />
                        :
                        ""
                    }
                </div>
                <RewardsSection
                    lang={props.lang}
                />
                {props.experiencias && props.experiencias.length > 0 ?
                    <ExperiencesSection
                        experiencias={props.experiencias}
                        ruta={props.ruta}
                        lang={props.lang}
                    />
                    :
                    ""
                }
            </main>
            <app-footer>
                <BrandsSection
                    lang={props.lang}
                    marcas={props.marcas}
                    ruta={props.ruta}
                />
                <Footer
                    lang={props.lang}
                    config={props.websgrupo}
                />
            </app-footer>
        </>
    );
}

export default Inicio;
